<template>
  <el-container
    direction="vertical"
    class="preview-ctr"
    v-bind:style="{ background: layoutBackgroundColor }"
  >
    <header-comp :headerConfig="headerConfig" />
    <div class="fl-content-ctr">
      <div>
        <fl-content />
      </div>
    </div>
    <footer-comp />
  </el-container>
</template>

<script>
import Header from './flHeader.vue'
import Footer from './flFooter.vue'
import FLContent from './flContent.vue'
import { custToolHelper } from '../../mixins/custToolHelper'

export default {
  components: {
    'header-comp': Header,
    'footer-comp': Footer,
    'fl-content': FLContent
  },
  props: {},
  data() {
    return {}
  },
  created() {},
  mixins: [custToolHelper],
  computed: {
    headerConfig() {
      let config = {
        headerText: 'Select a Site'
      }
      return config
    },
    layoutBackgroundColor() {
      return this.getItemDefaultValue('fl-finapp', 'layout_background_color')
    }
  },
  methods: {}
}
</script>

<style>
.preview-ctr {
  width: 800px;
  /* border: 1px solid #ccc; */
  margin: 0 auto;
}
</style>
